/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MainLeaks } from './MainLeaks';
import {
    MainLeaksFromJSON,
    MainLeaksFromJSONTyped,
    MainLeaksToJSON,
} from './MainLeaks';

/**
 * 
 * @export
 * @interface MonitGetEntityDataleaksSumQueries
 */
export interface MonitGetEntityDataleaksSumQueries {
    /**
     * 
     * @type {string}
     * @memberof MonitGetEntityDataleaksSumQueries
     */
    process_id?: string;
    /**
     * 
     * @type {MainLeaks}
     * @memberof MonitGetEntityDataleaksSumQueries
     */
    main_leaks?: MainLeaks;
    /**
     * 
     * @type {number}
     * @memberof MonitGetEntityDataleaksSumQueries
     */
    features_count?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitGetEntityDataleaksSumQueries
     */
    events_count?: number;
    /**
     * 
     * @type {boolean}
     * @memberof MonitGetEntityDataleaksSumQueries
     */
    exclude_main_leaks?: boolean;
}

/**
 * Check if a given object implements the MonitGetEntityDataleaksSumQueries interface.
 */
export function instanceOfMonitGetEntityDataleaksSumQueries(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitGetEntityDataleaksSumQueriesFromJSON(json: any): MonitGetEntityDataleaksSumQueries {
    return MonitGetEntityDataleaksSumQueriesFromJSONTyped(json, false);
}

export function MonitGetEntityDataleaksSumQueriesFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitGetEntityDataleaksSumQueries {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'process_id': !exists(json, 'process_id') ? undefined : json['process_id'],
        'main_leaks': !exists(json, 'main_leaks') ? undefined : MainLeaksFromJSON(json['main_leaks']),
        'features_count': !exists(json, 'features_count') ? undefined : json['features_count'],
        'events_count': !exists(json, 'events_count') ? undefined : json['events_count'],
        'exclude_main_leaks': !exists(json, 'exclude_main_leaks') ? undefined : json['exclude_main_leaks'],
    };
}

export function MonitGetEntityDataleaksSumQueriesToJSON(value?: MonitGetEntityDataleaksSumQueries | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'process_id': value.process_id,
        'main_leaks': MainLeaksToJSON(value.main_leaks),
        'features_count': value.features_count,
        'events_count': value.events_count,
        'exclude_main_leaks': value.exclude_main_leaks,
    };
}

